module.exports = __webpack_public_path__ + "static/media/subscribe.8ea86a38.svg";